export const WIDGET_BUNDLE_FILE_NAME = 'cashier-widget-component';
